<template>
  <div class="filter-price">
    <div
      class="filter-price-list"
      v-if="filterItem.method == 'list'"
      ref="filterPriceList"
    >
      <el-checkbox-group
        v-model="list_value_price"
        @change="change_list_price($event)"
      >
        <template v-for="(item, index) in filterItem.manual_price || []">
          <el-checkbox
            v-if="item.price_area"
            :key="item.price_area + index"
            :label="item.price_area"
          >
            <span class="inline">
              {{ list_price_filters(item.price_area) }}
            </span>
            <span v-if="filterItem.count_display" class="size-num">
              ({{ item.filter_count || item.product_count || "0" }})
            </span>
          </el-checkbox>
        </template>
      </el-checkbox-group>
    </div>
    <div class="filter-price-slider" v-else>
      <div class="input-min-max" v-if="!filterItem.slider_box">
        <el-input
          v-model="min"
          placeholder="min"
          @change="change_slider_price($event, 'min')"
        ></el-input>
        -
        <el-input
          v-model="max"
          placeholder="max"
          @change="change_slider_price($event, 'max')"
        ></el-input>
      </div>
      <div style="padding: 0 2px 20px 5px">
        <el-slider
          @touchstart.native="showTooltip = true"
          @touchend.native="showTooltip = false"
          tooltip-class="filter-mb-tooltip"
          :show-tooltip="showTooltip"
          v-model="slider_value_price"
          range
          :min="price_value_min"
          :max="price_value_max"
          :marks="marks"
          @change="change_slider_price($event, 'range')"
        >
        </el-slider>
      </div>
    </div>
  </div>
</template>
<script>
import getSymbolFromCurrency from "currency-symbol-map";
export default {
  props: ["filterItem", "payload", "payload_key"],
  data() {
    return {
      slider_value_price: [50, 100], //slider风格下v-model的值
      list_value_price: [], //list风格下v-model的值
      min: 0,
      max: 0,
      showTooltip: true,
      marks: {},
      price_value_min: {},
      price_value_max: {},
    };
  },
  methods: {
    slider_price_filters() {
      let { rates, pricetype } = this.$store.state;
      let { min, max, num } = this.filterItem.price_value;
      min = (min * rates[pricetype]) | 0;
      max = (max * rates[pricetype]) | 0;
      this.price_value_min = min;
      this.price_value_max = max;
      this.marks = {
        [min]: `${this.priceSymbol}${min}`,
        [max]: `${this.priceSymbol}${max}`,
      };
      num = parseInt(num);
      let mean_value = (max - min) / num;
      if (num > 1 && mean_value >= 1) {
        for (let index = 1; index < num; index++) {
          let node_num = parseInt(index * mean_value + min);
          this.marks[node_num] = `${this.priceSymbol}${node_num}`;
        }
      }
      this.reset_slider_price();
    },
    list_price_filters(val) {
      let { rates, pricetype } = this.$store.state;
      let [a, b] = val.split(":");
      a = a ? (a * rates[pricetype]) | 0 : a;
      b = b ? (b * rates[pricetype]) | 0 : b;
      if (b) {
        a = a == "0" ? "Under " : this.priceSymbol + a + " - ";
        b = this.priceSymbol + b;
      } else {
        b = this.priceSymbol + a;
        a = "Above";
      }
      return a + b;
    },
    change_list_price(num) {
      let payload = {
        [this.payload_key]: [...num],
      };
      this.bus.$emit("changeFilter", payload);
    },
    reset_slider_price() {
      if (this.min && this.max && this.min - 0 > this.max - 0) {
        [this.min, this.max] = [this.max, this.min];
      }
      if (this.min < this.price_value_min || !this.min) {
        this.min = this.price_value_min;
      }
      if (this.max > this.price_value_max || !this.max) {
        this.max = this.price_value_max;
      }
    },
    change_slider_price(num, type) {
      this.reset_slider_price();
      let payload = {
        [this.payload_key]: [parseInt(this.min), parseInt(this.max)],
      };
      if (type == "range") {
        payload[this.payload_key][0] = num[0];
        payload[this.payload_key][1] = num[1];
      }
      this.bus.$emit("changeFilter", payload);
    },
  },
  computed: {
    priceSymbol() {
      return getSymbolFromCurrency(this.$store.state.pricetype);
    },
  },
  watch: {
    "$store.state.pricetype": {
      handler(newV) {
        this.slider_price_filters();
      },
      immediate: true,
    },
    payload: {
      handler(newV) {
        if (!newV) return;
        if (this.filterItem.method == "list") {
          this.list_value_price = [...newV];
          return;
        }
        let [min, max] = [newV[0]??0, newV[1]??this.price_value_max];
        this.min = min;
        this.max = max;
        this.slider_value_price = [min, max];
      },
      immediate: true,
      deep: true,
    },
  },
  beforeMount() {
    //若价格为list 则无需操作
    if (this.filterItem.method == "list") return;
    this.slider_value_price = [this.payload[0], this.payload[1]];

    this.slider_price_filters();
    // console.log(this.marks,num,mean_value,'mean_valuemean_valuemean_valuemean_value');
  },
};
</script>
<style scoped lang='scss'>
.filter-price {
  .filter-price-list {
    display: flex;
    &::v-deep .el-checkbox-group {
      width: 100%;
      .el-checkbox {
        margin-right: 0;
        width: 100%;
        display: flex;
        align-items: flex-start;
        font-family: "Muli";
        margin-bottom: 10px;
        &:hover {
          opacity: 0.7;
        }
        .el-checkbox__input {
          padding-top: 3px;
          .el-checkbox__inner {
            width: 18px;
            height: 18px;
            border-color: #dcdfe6 !important;
            &::after {
              left: 6px;
              top: 3px;
            }
          }
        }
        &.is-checked .el-checkbox__input {
          .el-checkbox__inner {
            background-color: var(--main-btn-bg) !important;
            color: var(--main-btn-tx) !important;
            border-color: transparent !important;
          }
        }
        .el-checkbox__label {
          flex: 1;
          color: #606266;
          display: flex;
          line-height: 24px;
          justify-content: space-between;
          font-size: 13px;
          span:first-child {
            white-space: initial;
          }
          .size-num {
            float: right;
          }
        }
      }
    }
  }
  .filter-price-slider {
    display: flex;
    flex-wrap: wrap;
    & > div {
      width: 100%;
    }
    .input-min-max {
      display: flex;
      justify-content: space-between;
      align-items: center;
      & ::v-deep .el-input {
        width: 40%;
        .el-input__inner {
          height: 30px;
          line-height: 30px;
          padding: 0 10px;
          margin: 0;
          &:focus {
            border-color: #dcdfe6;
          }
        }
      }
    }
    & ::v-deep .el-slider {
      .el-slider__runway {
        background-color: black;
        height: 2px;
        .el-slider__button-wrapper {
          top: -16.5px;
          z-index: 5;
          .el-slider__button {
            width: 12px;
            height: 12px;
            border-color: black;
          }
        }
        .el-slider__stop {
          height: 6px;
          width: 2px;
          border-radius: unset;
          background-color: black;
          transform: translate(-50%, -30%);
        }
        .el-slider__bar {
          background-color: black;
          height: 2px;
        }
        .el-slider__marks {
          .el-slider__marks-text {
            font-size: 12px;
            color: black;
            white-space: nowrap;
          }
        }
      }
    }
  }
  .inline {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    padding-bottom: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-overflow: -o-ellipsis-lastline;
  }
}
</style>
